var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBilling1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 4.33333V11.5C2.5 12.6046 3.39543 13.5 4.5 13.5H13.5V5.83333H10.8333M2.5 4.33333C2.5 5.16176 3.17157 5.83333 4 5.83333H10.8333M2.5 4.33333C2.5 3.32081 3.32081 2.5 4.33333 2.5H10.8333V5.83333",
    stroke: "#263DFF",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 10.2502C10.6555 10.2502 10.9167 9.989 10.9167 9.66683C10.9167 9.34466 10.6555 9.0835 10.3333 9.0835C10.0112 9.0835 9.75 9.34466 9.75 9.66683C9.75 9.989 10.0112 10.2502 10.3333 10.2502Z",
    fill: "#263DFF",
    stroke: "#263DFF",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilling1);
export default __webpack_public_path__ + "static/media/billing1.d755cb64fe3f75dd3e9bbb66d6efe47f.svg";
export { ForwardRef as ReactComponent };